import CONFIG from "../utils/config";

//send Otp
export const sendOtp = async (mobileNumber,policyNumbeOrQueId) => {
  try {
    const url = `${CONFIG.WHATSAPPURL}/otp/send`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobileNumber,policyNumbeOrQueId }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send OTP. Status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw error.message || error;
  }
};


// OTP verification
export const verifyOtp = async (mobileNumber, otp,policyNumbeOrQueId) => {
  const url = `${CONFIG.WHATSAPPURL}/otp/verification`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobileNumber, otp,policyNumbeOrQueId }),
    });

    if (!response.ok) {
      throw new Error(`OTP verification failed. Status: ${response.status}`);
    }

    return await response.json();
  } catch (err) {
    throw err.message || err;
  }
};



